import React, { Component } from "react";
import { PieChart, Pie, Cell, ResponsiveContainer } from "recharts";

export default class Piechart extends Component {
  renderCustomizedLabel = ({
    cx,
    cy,
    midAngle,
    innerRadius,
    outerRadius,
    index,
  }) => {
    let label;
    const radius = outerRadius + 7;
    const RADIAN = Math.PI / 180;
    const x = cx + radius * Math.cos(-midAngle * RADIAN);
    const y = cy + radius * Math.sin(-midAngle * RADIAN);

    //Don't show label if value is 0
    label =
      this.props.data[index].value === 0 ? "" : this.props.data[index].value;
    return (
      <text
        x={x}
        y={y}
        fill="black"
        textAnchor={x > cx ? "start" : "end"}
        dominantBaseline="central"
      >
        {label}
      </text>
    );
  };

  render() {
    if (this.props.data.length > 0) {
      return (
        <ResponsiveContainer width="100%" height={160}>
          <PieChart>
            <Pie
              data={this.props.data}
              stroke={this.props.strokeColor}
              strokeWidth={this.props.strokeWidth}
              labelLine={false}
              label={this.renderCustomizedLabel}
              innerRadius="50%"
              outerRadius="90%"
              dataKey={"value"}
            >
              {this.props.data.map((entry, index) => (
                <Cell
                  key={Math.random()}
                  fill={this.props.colors[index % this.props.colors.length]}
                />
              ))}
            </Pie>
          </PieChart>
        </ResponsiveContainer>
      );
    } else {
      //in case of no data
    }
  }
}
